/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import Header from '../../../components/Header'
import Footer from '../../../components/footer'

import { useNavigate } from 'react-router-dom'

import { get, post } from '../../../services/https'

import { notify } from '../../../components/Toast'
import { ToastContainer } from 'react-toastify'

import trashIcon from '../../../assets/svg/trash.svg'

export default function index() {
  const navigate = useNavigate()

  const [addresses, setAddresses] = useState([])
  const [userId, setUserId] = useState('')
  
  useEffect(() => {
    post('/api/front/users/verify', {
      token: localStorage.getItem('token')
      }).then(response => {
        setUserId(response.data.data.userId)
        get(`/api/front/users/${response.data.data.userId}`)
          .then(responseUser => {
            setAddresses(responseUser.data.data.address)
          }).catch(error => {
            notify('error', 'ابتدا ثبت نام / ورود کنید')
            setTimeout(() => {
              navigate('/login')
            }, 3000)
          })
      }).catch(error => {
        notify('error', 'ابتدا ثبت نام / ورود کنید')
        setTimeout(() => {
          navigate('/login')
        }, 3000)
      })
  }, [navigate])

  const deleteHandler = (e) => {
    const addressId = e.target.id
    if (addressId.length > 0) {
      post(`/api/front/users/deleteAddress`, {
          id: userId,
          addressId 
        }).then(response => {
          notify('success', 'آدرس با موفقیت حذف شد')
          setAddresses(response.data.data.address)
        }).catch(error => {
          notify('error', 'خطا در ارسال اطلاعات')
        })
    }
  }

  return (
    <div id='profile'>
      <ToastContainer rtl />
      <Header name={'رستوران کانولی'} />
      <div className='body'>
      </div>
      <div className="scroll">
        <div className='profileTitle'>آدرس های شما</div>
        <div className='profileCard'>
          {addresses ? addresses.map((adress, index) => (
            <>
              <div className='item' key={index}>
                <span>{adress.addressSelect + ' پلاک : ' + adress.plak + ' طبقه : ' + adress.floor}</span>
                <span onClick={deleteHandler} id={index} className='trashIcon'><img id={index} style={{ width: '20px', cursor: 'pointer' }} src={trashIcon} alt="trashIcon" /></span>
              </div>
              <hr />
            </>
            )) : 'آدرسی موجود نیست'}

        { addresses.length === 0 ? 
          (
            <div className='emptyBasket'>
              آدرسی موجود نیست
            </div>
          ) : '' }
        </div>
      </div>
      <Footer page={'profile'} />
    </div>
  )
}
